
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/privacy/[date]",
      function () {
        return require("private-next-pages/[locale]/privacy/[date].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/privacy/[date]"])
      });
    }
  